enum AHStatusType {
  POSITIVE = "POSITIVE",
  NEGATIVE = "NEGATIVE",
  DEFAULT = "DEFAULT",
}
